(function () {
	const collapsibleContent = () => {
			$(".collapsible-content").each(function () {
					const $this = $(this);
					const sectionId = $this.data("id");

					// $this.find(".collapsible-content-summary").eq(0).addClass("active"); // commented

					// Hide all content initially
					$this.find(".collapsible-content-item__content").hide();

					$this.find(".collapsible-content-summary").click(function () {
							if (!$(this).hasClass("active")) {
									$this.find(".collapsible-content-summary.active").removeClass("active");
									$(this).addClass("active");
									$this.find(".collapsible-content-item__content").stop().slideUp(300);
									$(this)
											.siblings(".collapsible-content-item__content")
											.eq($(this).index())
											.stop()
											.slideDown(300);
							} else {
									$(this).removeClass("active");
									$(this)
											.siblings(".collapsible-content-item__content")
											.stop()
											.slideUp(300);
							}
					});
			});
	};

	collapsibleContent();

	document.addEventListener("shopify:section:load", function () {
			setTimeout(() => {
					collapsibleContent();
			}, 100);
	});
})();
